export enum BlogCategory {
  CALL_ANALYSIS = "call-analysis",
  CUSTOMER_KNOWLEDGE = "customer-knowledge",
  WIN_LOSS = "win-loss",
  AI_TOOLS = "ai-tools",
}
